import { useFetch } from '@/composables/useFetch';
import { useToast } from '@/composables/useToast';
import { endpointsList } from '@/helpers';
import axios from 'axios';
import { IWorkspaceDetailsDto } from 'types';
import { useI18n } from 'vue-i18n';

export function useGetWorkspace(workspaceId: string, autoFetch = true) {
  const { data, fetchData, isLoading } = useFetch(
    () => getWorkspace(workspaceId),
    undefined,
    autoFetch,
  );
  const { t } = useI18n();
  const { createErrorToast } = useToast();

  async function getWorkspace(workspaceId: string) {
    try {
      const response = await axios.get<IWorkspaceDetailsDto>(
        endpointsList.workspaces.getWorkspaceById(workspaceId),
      );
      return response.data;
    } catch {
      createErrorToast(t('workspaces.errors.errorGettingWorkspaceDetails'));
    }
  }

  return {
    workspace: data,
    fetchWorkspace: fetchData,
    isLoadingWorkspace: isLoading,
  };
}
